import { render, staticRenderFns } from "./RoleActionLog.vue?vue&type=template&id=10ed6295&scoped=true"
import script from "./RoleActionLog.vue?vue&type=script&lang=js"
export * from "./RoleActionLog.vue?vue&type=script&lang=js"
import style0 from "./RoleActionLog.vue?vue&type=style&index=0&id=10ed6295&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed6295",
  null
  
)

export default component.exports